<template>
  <div class="app-template d-flex flex-column" :class="{'app-template--mobile': isMobile }">
    <app-header />
    <div class="content-wrapper">
      <slot />
    </div>
    <!-- <privacy-menu v-if="!isMobile" type="desktop"/> -->
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useCommonStore } from '@/store/common';
import AppHeader from '@/components/common/AppHeader/AppHeader.vue';

const { isMobile } = storeToRefs(useCommonStore());
</script>

<style scoped lang="scss" src="./TemplateApp.scss" />
